export default {
  ADD_DATA_PAGE(state, payload) {
    state.data.push(payload);
  },
  SET_DATA_CURRENTPAGE(state, payload) {
    state.currentPage = payload; // eslint-disable-line
  },
  CHANGE_LANG(state, payload) {
    state.currentLang = payload; // eslint-disable-line
  },
};
